import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ApplicationActions = createActionGroup({
    source: 'Application',
    events: {
        'No op Action': emptyProps(),
        'Set current Rundown view state': props<{ guid: string }>(),
    },
});
